<mat-card id="workOrderLineListCard" class="custom-card-no-shadow mt-2" appearance="outlined">
  <mat-card-content id="workOrderLineListContent" class="cam-table">
    <mat-form-field id="wolSearchField" class="wol-search-field" subscriptSizing="dynamic">
      <mat-label>{{ translationService.translate('SearchText') }}</mat-label>
      <input id="wolSearchInput" matInput [formControl]="searchControl" [placeholder]="getSearchInputTranslation()" autocomplete="off" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
    <mic-table appCopyOnSelect id="workOrderLinesTable" class="table-stripped btn-table" [config]="tableConfig" [fetcher]="fetcher">
      <ng-container *micTableColumnSelector>
        <button id="columnsButton" mat-flat-button color="primary" [matMenuTriggerFor]="colMenu" (click)="$event.stopPropagation()">
          <mat-icon>view_column</mat-icon>
          {{ translationService.translate('columnsButtonText') }}
        </button>
        <mat-menu #colMenu="matMenu">
          <div
            class="column-menu-content column-menu-list"
            cdkDropList
            [cdkDropListData]="columnOrder"
            (cdkDropListDropped)="onColumnDrop($event)"
          >
            @for (key of columnOrder; track key) {
            <div class="column-menu-item" cdkDrag>
              <mat-icon class="column-drag-handle" cdkDragHandle aria-hidden="true">drag_indicator</mat-icon>
              <mat-checkbox [checked]="columnVisibility[key]" (click)="$event.stopPropagation()" (change)="toggleColumn(key)">
                {{ columnNames[key] || key }}
              </mat-checkbox>
            </div>
            }
          </div>
        </mat-menu>
      </ng-container>
      <!--      Forced disable as it going to be use for bluk delete-->
      @if (isDeleteWorkOrderEnabled && false) {
      <ng-container *micTableActions="let items">
        <button mat-flat-button color="warn">
          <mat-icon class="delete-icon-only">delete</mat-icon>
          {{ translationService.translate('deleteText') }}
        </button>
      </ng-container>
      }
      <ng-container *micTableRowMenu="let item">
        @if (isDeleteWorkOrderEnabled) {
        <span
          [matTooltip]="!isDeletableCasingStatus(item.casingStatus) ? translationService.translate('notEligibleToDeleteText') : ''"
          [matTooltipDisabled]="isDeletableCasingStatus(item.casingStatus)"
          matTooltipPosition="above"
        >
          <button
            id="delete-work-order-line"
            type="button"
            (click)="onDeleteClick(item)"
            [disabled]="!isDeletableCasingStatus(item.casingStatus)"
            mat-menu-item
          >
            <mat-icon class="delete-icon-only">delete</mat-icon> {{ translationService.translate('deleteWOLineText') }}
          </button>
        </span>
        }
      </ng-container>
      <ng-container *micTableNoData>
        <mic-empty-state
          id="emptyTableState"
          icon="layers_clear"
          title="{{ translationService.translate('emptyTableText') }}"
        ></mic-empty-state>
      </ng-container>
    </mic-table>
  </mat-card-content>
</mat-card>
